module.exports = __webpack_public_path__ + "static/media/hardware.d43b4c13.jpg";